"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _sizes = require("HubStyleTokens/sizes");

var _Color = require("../core/Color");

var _HoverProvider = _interopRequireDefault(require("../providers/HoverProvider"));

var _colors = require("HubStyleTokens/colors");

var _UICloseButton = _interopRequireDefault(require("../button/UICloseButton"));

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  top: ", ";\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  @media only screen and (min-width: 50em) {\n    color: ", ";\n    position: absolute;\n    ", ";\n\n    &::after {\n      background: ", ";\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  right: 40px;\n  top: 40px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var getOffset = (0, _styledComponents.css)(_templateObject());

var getDetachedStyle = function getDetachedStyle(hovered, size) {
  return (0, _styledComponents.css)(_templateObject2(), hovered && _colors.MONOLITH, size === 'xl' && getOffset, (0, _Color.rgba)(_colors.OLAF, 0.1));
};

var CloseButton = (0, _styledComponents.default)(function (props) {
  var __detached = props.detached,
      rest = (0, _objectWithoutProperties2.default)(props, ["detached"]);
  return _react.default.createElement(_UICloseButton.default, rest);
}).withConfig({
  displayName: "UIDialogCloseButton__CloseButton",
  componentId: "p67wdn-0"
})(_templateObject3(), _sizes.MODAL_CLOSE_BUTTON_OFFSET, function (props) {
  return props.detached && getDetachedStyle(props.hovered, props.size);
});

var UIDialogCloseButton = _react.default.createClass({
  displayName: "UIDialogCloseButton",
  propTypes: {
    detached: _propTypes.default.bool.isRequired,
    size: _UICloseButton.default.propTypes.size
  },
  getDefaultProps: function getDefaultProps() {
    return {
      detached: false
    };
  },
  render: function render() {
    var _this$props = this.props,
        className = _this$props.className,
        detached = _this$props.detached,
        size = _this$props.size,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["className", "detached", "size"]);
    var computedSize = detached && size == null ? 'xl' : size;
    return _react.default.createElement(_HoverProvider.default, this.props, function (hoverProviderProps) {
      return _react.default.createElement(CloseButton, (0, _extends2.default)({
        className: (0, _classnames.default)('uiDialog-closeButton', 'private-modal__control', 'private-modal__close', className)
      }, rest, hoverProviderProps, {
        detached: detached,
        size: computedSize
      }));
    });
  }
});

var _default = UIDialogCloseButton;
exports.default = _default;
module.exports = exports.default;